/* eslint-disable */
export default [
  require('../assets/img/web/androidbutton.png'),
  require('../assets/img/web/androidhover.png'),
  require('../assets/img/web/applebutton.png'),
  require('../assets/img/web/applehover.png'),
];
